<template>
  <v-container fluid pa-0>
    <v-layout column>
      <!-- MESSAGE FOR CLEAR WHO -->
      <v-dialog
        v-model="showMessageClearWho"
        persistent
        max-width="390"
      >
        <message-clear-who
          :vehicles="vehiclesAttached.length"
          @clearVehiclesFromMessage="clearVehiclesFromMessage"
          @closeMessageClearWho="closeMessageClearWho"
        />
      </v-dialog>
      <!-- MESSAGE -->
      <v-dialog
        v-model="showDialogMessage"
        persistent
        max-width="400"
      >
        <create-mission-message
          :message="messageToShow"
          @nextMission="nextMission"
          @fihishCreateMission="fihishCreateMission"
        />
      </v-dialog>
      <!-- MAIN CONTENT -->
      <v-card>
        <v-toolbar class="pr-2" color="grey darken-3" flat>
          <v-toolbar-title>Creación Minutas de Servicio</v-toolbar-title>
        </v-toolbar>
        <v-toolbar dense flat>
          <v-toolbar-title>Qué y Dónde</v-toolbar-title>
        </v-toolbar>
        <!-- LOADING MISSIONS BASE TREE -->
        <v-flex v-if="$loading.isLoading('fetchMissionsTemplates')" pa-3>
          <h3>Cargando listado de Misiones...</h3>
          <v-progress-circular color="primary" indeterminate class="ma-3" />
        </v-flex>
        <v-flex v-else d-flex py-3>
          <v-flex style="max-width: 550px;min-width: 550px;" px-2>
            <v-treeview
              v-bind="selected"
              item-key="id"
              item-text="name"
              activatable
              active-class="primary"
              :items="missionsTemplates"
              :active.sync="activeM"
            ></v-treeview>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex px-3>
            <v-flex v-if="selections.length === 0">
              <h3>Seleccionar una misión</h3>
              <v-flex py-5 class="text-xs-center">
                <v-avatar
                  size="100px"
                  color="grey darken-4">
                  <v-icon color="grey darken-3" size="80px">flag</v-icon>
                </v-avatar>
              </v-flex>
            </v-flex>
            <v-flex v-else>
              <h3>
                {{ selections.length === 1 ? 'Misión Seleccionada' : 'Misiones Seleccionadas' }}
              </h3>
              <!-- SELECTIONS -->
              <v-scroll-x-transition
                group
                hide-on-leave
              >
                <v-flex
                  v-for="(selection, i) in selections"
                  :key="i"
                  py-1
                >
                  <v-flex pb-2>
                    <v-chip
                      color="grey lighten-4"
                      dark
                      small
                    >
                      <v-icon left small color="grey darken-4">mdi-check-circle</v-icon>
                      <v-flex d-flex>
                        <v-flex class="name-selection">
                          <b>{{ `${selection.name} -` }}</b>
                        </v-flex>
                        <v-flex class="description-selection">
                          {{ `| ${selection.description}` }}
                        </v-flex>
                      </v-flex>
                    </v-chip>
                  </v-flex>
                  <v-flex v-if="selection.where.length > 1" px-3 py-1>
                    <v-select
                      v-model="whereSelected"
                      :items="whereData(selection.where)"
                      item-text="text"
                      item-value="value"
                      label="Dónde"
                      multiple
                      box
                      clearable
                    ></v-select>
                  </v-flex>
                  <v-divider></v-divider>
                </v-flex>
              </v-scroll-x-transition>
              <!-- ANALYZE PARKING CHECKBOX -->
              <v-checkbox
                v-model="analyzeParkingCheckbox"
                label="Seguimiento de Estacionarias Prolongadas"
              ></v-checkbox>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex v-if="selections.length > 0" d-flex mb-3>
        <!-- <v-flex d-flex mb-3> -->
          <!-- WHEN -->
          <v-flex style="max-width: 550px;min-width: 550px;">
            <v-toolbar dense flat>
              <v-toolbar-title>Cuándo</v-toolbar-title>
            </v-toolbar>
            <!-- TYPE OF WHEN -->
            <v-flex px-3 pt-3>
              <v-autocomplete
                :items="whenTypes"
                v-model="whenTypeSelection"
                label="Seleccionar Tipo"
                item-text="text"
                item-value="value"
                single-line
                clearable
                box
                @change="clearWhenData"
              />
            </v-flex>
            <!-- ------------------------- -->
            <!-- CUSTOM -->
            <!-- ------------------------- -->
            <!-- DATE SELECTION -->
            <v-flex v-if="whenTypeSelection === 'custom'" px-3>
              <v-flex d-inline-flex align-center>
                <v-flex style="max-width: 20px;">
                  <v-icon color="grey">event</v-icon>
                </v-flex>
                <v-flex>
                  <v-subheader style="font-weight: bolder">Fecha</v-subheader>
                </v-flex>
              </v-flex>
              <!-- INPUT TEXT -->
              <v-flex d-flex >
                <v-flex xs6 pr-2>
                  <v-menu
                    ref="startDate"
                    v-model="startDateMenu"
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="startDate"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha de inicio"
                      v-model="startDate"
                      prepend-inner-icon="event"
                      readonly
                      box
                    ></v-text-field>
                    <v-date-picker
                      v-model="startDate"
                      no-title
                      scrollable
                      locale="es"
                      :allowed-dates="allowedDatesStartDate"
                      @change="startDateChanges"
                    >
                      <v-spacer></v-spacer>
                      <v-btn color="error" @click="startDateMenu = false">Cancelar</v-btn>
                      <v-btn color="primary" @click="$refs.startDate.save(startDate)">Elegir</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6 pl-2>
                  <v-menu
                    ref="endDate"
                    v-model="endDateMenu"
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    :return-value.sync="endDate"
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha de fin"
                      v-model="endDate"
                      prepend-inner-icon="event"
                      readonly
                      box
                    />
                    <v-date-picker 
                      v-model="endDate" 
                      no-title 
                      scrollable 
                      locale="es"
                      :allowed-dates="allowedDatesCustom"
                      @change="endDateChanges"
                    >
                      <v-spacer></v-spacer>
                      <v-btn color="error" @click="endDateMenu = false">Cancelar</v-btn>
                      <v-btn color="primary" @click="$refs.endDate.save(endDate)">Elegir</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-flex>
            </v-flex>
            <!-- TIME SELECTION -->
            <v-flex v-if="endDate && whenTypeSelection === 'custom'" px-3>
              <v-flex d-inline-flex align-center>
                <v-flex style="max-width: 20px;">
                  <v-icon color="grey">access_time</v-icon>
                </v-flex>
                <v-flex>
                  <v-subheader style="font-weight: bolder">Tiempo</v-subheader>
                </v-flex>
              </v-flex>
              <v-flex d-flex>
                <!-- START TIME -->
                <v-flex xs6 pr-2>
                  <!-- :nudge-right="40" -->
                  <v-menu
                    ref="startTime"
                    v-model="startTimeMenu"
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :return-value.sync="startTime"
                  >
                    <v-text-field
                      slot="activator"
                      label="Hora de inicio"
                      v-model="startTime"
                      prepend-inner-icon="access_time"
                      readonly
                      box
                    ></v-text-field>
                    <v-time-picker
                      v-model="startTime"
                      ref="startTimePicker"
                      format="24hr"
                      scrollable
                      landscape
                      @input="changeStartTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn color="error" @click="startTimeMenu = false">Cancelar</v-btn>
                      <v-btn color="primary" @click="acceptStartTime">Aceptar</v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <!-- END TIME -->
                <v-flex v-if="showEndTime" xs6 pl-2>
                  <v-menu
                    ref="endTime"
                    v-model="endTimeMenu"
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :return-value.sync="endTime"
                  >
                    <v-text-field
                      slot="activator"
                      label="Hora de fin"
                      v-model="endTime"
                      prepend-inner-icon="access_time"
                      readonly
                      box
                    />
                    <!-- :allowed-minutes="allowedMinutes" -->
                    <!-- :allowed-hours="allowedHours" -->
                    <v-time-picker 
                      v-model="endTime"
                      ref="endTimePicker"
                      format="24hr"
                      scrollable
                      landscape
                      :allowed-hours="allowedEndHour"
                      :allowed-minutes="allowedEndMinute"
                      @click:hour="clickedHourEndTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn color="error" @click="endTimeMenu = false">Cancelar</v-btn>
                      <v-btn color="primary" @click="$refs.endTime.save(endTime)">Aceptar</v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-flex>
              </v-flex>
            </v-flex>
            <!-- ------------------------- -->
            <!-- TURN -->
            <!-- ------------------------- -->
            <v-flex v-if="whenTypeSelection === 'turn'" px-3>
              <v-flex d-inline-flex align-center>
                <v-flex style="max-width: 20px;">
                  <v-icon color="grey">timelapse</v-icon>
                </v-flex>
                <v-flex>
                  <v-subheader style="font-weight: bolder">Turno</v-subheader>
                </v-flex>
              </v-flex>
              <v-autocomplete
                :items="turnTypes"
                v-model="turnTypesSelection"
                label="Seleccionar Turno"
                item-text="text"
                item-value="value"
                single-line
                clearable
                box
              />
              <!-- DATE SELECTION -->
              <v-flex v-if="turnTypesSelection && whenTypeSelection === 'turn'">
                <v-flex d-inline-flex align-center>
                  <v-flex style="max-width: 20px;">
                    <v-icon color="grey">event</v-icon>
                  </v-flex>
                  <v-flex>
                    <v-subheader style="font-weight: bolder">Fecha</v-subheader>
                  </v-flex>
                </v-flex>
                <!-- INPUT TEXT -->
                <v-flex d-flex >
                  <v-flex xs6 pr-2>
                    <v-menu
                      ref="startDateTurn"
                      v-model="startDateTurnMenu"
                      lazy
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      min-width="290px"
                      :return-value.sync="startDate"
                    >
                      <v-text-field
                        slot="activator"
                        label="Fecha de inicio"
                        v-model="startDateTurn"
                        prepend-inner-icon="event"
                        readonly
                        box
                      ></v-text-field>
                      <v-date-picker
                        v-model="startDateTurn"
                        no-title
                        scrollable
                        locale="es"
                        :allowed-dates="allowedDatesStartDate"
                      >
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="startDateTurnMenu = false">Cancelar</v-btn>
                        <v-btn color="primary" @click="$refs.startDateTurn.save(startDateTurn)">Elegir</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- <v-spacer></v-spacer>
                  <v-flex xs6 pl-2>
                    <v-menu
                      ref="endDateTurn"
                      v-model="endDateTurnMenu"
                      lazy
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      max-width="290px"
                      min-width="290px"
                      :return-value.sync="endDate"
                    >
                      <v-text-field
                        slot="activator"
                        label="Fecha de fin"
                        v-model="endDateTurn"
                        prepend-inner-icon="event"
                        readonly
                        box
                      />
                      <v-date-picker
                        v-model="endDateTurn"
                        no-title
                        scrollable
                        locale="es"
                        :allowed-dates="allowedDatesTurn"
                      >
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="endDateTurnMenu = false">Cancelar</v-btn>
                        <v-btn color="primary" @click="$refs.endDateTurn.save(endDateTurn)">Elegir</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex> -->
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
          <!-- WHO -->
          <v-divider vertical></v-divider>
          <v-flex>
            <v-flex>
              <v-toolbar dense flat>
                <v-toolbar-title>Quién</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-flex>
              <v-card-text style="min-height: 200px">
                <v-layout>
                  <!-- SEARCH VEHICLE -->
                  <v-flex style="max-width:390px;min-width:390px;" pr-3>
                    <v-text-field
                      ref="search"
                      v-model="searchVehicleValue"
                      flat
                      box
                      prepend-inner-icon="search"
                      color="white"
                      label="Código/Sigla ó Placa"
                      :disabled="loadingSave"
                      @keyup.enter="searchVehicle"
                    >
                    </v-text-field>
                    <!-- SEARCH -->
                    <v-scroll-x-transition>
                      <v-flex  v-if="searchAction" class="container-search-result" mb-2>
                        <v-flex d-flex align-center>
                          <v-flex class="h7" pl-4>
                            <b>Resultado</b>
                          </v-flex>
                          <v-flex class="text-xs-right" pr-3>
                            <v-btn 
                              color="white"
                              flat
                              small
                              fab
                              @click="clearSearch">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-flex>
                        <!-- <transition name="fade"> -->
                        <v-flex v-if="searchVehicleResult.length > 0">
                          <!-- ALREADY ADDED -->
                          <v-flex v-if="vehicleAlreadyAdded" class="h7" pl-4 pb-3>
                            El vehículo ya fue agregado a la lista.
                          </v-flex>
                          <v-flex
                            v-else
                            v-for="(vehicle, index) in searchVehicleResult"
                            :key="index"
                            class="text-xs-center info-vehicle-r pointer-1"
                            d-flex
                            mx-4
                            align-center
                            @click="addWho(vehicle)"
                          >
                            <v-flex pr-2>
                              {{ vehicle.code }}
                            </v-flex>
                            <v-flex style="width: 80px;min-width: 60px;" pr-4>
                              <v-flex class="plate-border">
                                {{ vehicle.licensePlate }}
                              </v-flex>
                            </v-flex>
                            <v-flex style="max-width: 30px;min-width: 30px;" pr-1>
                              <v-icon>add</v-icon>
                            </v-flex>
                          </v-flex>
                          <br>
                        </v-flex>
                        <!-- NOT FOUND -->
                        <v-flex v-else>
                          <v-flex class="h7" pl-4 pb-3>
                            No se encontró vehículo válido para la misión seleccionada!
                          </v-flex>
                        </v-flex>
                        <!-- </transition> -->
                      </v-flex>
                    </v-scroll-x-transition>
                    <!-- </transition> -->
                  </v-flex>
                  <v-divider vertical></v-divider>
                  <!-- VEHICLE LIST -->
                  <v-flex>
                    <v-card
                      class="CreateMissionView__card"
                      elevation="0"
                      width="390"
                      height="360"
                    >
                      <v-card-title class="subheader">
                        <v-flex d-inline-flex align-baseline>
                          <h4 style="max-width:170px;">Vehículos seleccionados:</h4>
                          <h3>{{ vehiclesAttached.length }}</h3>
                        </v-flex>
                      </v-card-title>
                      <!-- LIST -->
                      <v-flex
                        id="container-who-0"
                        class="scroll-section"
                        ml-2
                      >
                        <v-flex
                          v-for="(vehicle, index) in vehiclesAttached"
                          :key="index"
                          pt-1 px-1
                        >
                          <!-- <v-list-tile-content> -->
                          <v-flex
                            :class="[index % 2 ? rowbgalt : rowbg]"
                            d-inline-flex
                            align-center
                          >
                            <v-flex
                              class="list-who body-2"
                              d-flex
                              align-center
                            >
                              {{ 
                                `${vehicle.code !== null ? vehicle.code : ''} | ${vehicle.licensePlate}` 
                              }}
                            </v-flex>
                            <v-flex>
                              <v-btn
                                flat
                                small
                                icon
                                @click="deleteFromDraggableList(index,vehiclesAttached)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <!-- CLEAR LIST -->
                      <v-flex 
                        v-if="vehiclesAttached.length > 0" 
                        xs12 
                        class="text-xs-left"
                        pl-2
                      >
                        <v-btn
                          small
                          block
                          color="error"
                          @click="clearVehiclesAttached"
                        >
                          <v-icon left>clear</v-icon>
                          Limpiar
                        </v-btn>
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-layout>

              </v-card-text>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-divider v-if="selections.length > 0" class="mx-3"></v-divider>
        <v-flex v-if="selections.length > 0" class="text-xs-center" my-3>
          <v-btn
            color="success"
            style="width: 290px;"
            :disabled="!readyToSaveMission"
            :loading="loadingSave"
            @click="saveMission"
          >
            <v-icon left>
              backup
            </v-icon>
            Guardar
          </v-btn>
        </v-flex>
      </v-card>
    </v-layout>
  </v-container>

</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import { missionsMixin } from '../../mixins/missionsMixin'
  import { agenciesMixin } from '../../mixins/agenciesMixin'

  import CreateMissionMessage from './CreateMissionMessage'
  import MessageClearWho from './MessageClearWho'

  /**
   * Componente que contiene el formulario de creación para Misiones
   *
   * @author Manuel Ochoa
   */
  export default {
    name: 'create-mission-view',
    mixins: [
      agenciesMixin,
      missionsMixin
    ],
    components: {
      CreateMissionMessage,
      MessageClearWho
    },
    data() {
      return {
        vehicleAlreadyAdded: false,
        messageToShow: {},
        showDialogMessage: false,
        selectionsAgencies: [],
        showEndTime: false,
        startDateTurn: '',
        endDateTurn: '',
        startDateTurnMenu: false,
        endDateTurnMenu: false,
        turnTypesSelection: '',
        turnTypes: [
          {text: 'Turno 2', value: ['06:00', '14:00']},
          {text: 'Turno 3', value: ['14:00', '22:00']},
          {text: 'Turno 4-1', value: ['22:00', '06:00']}
        ],
        whenTypeSelection: '',
        whenTypes: [
          {text: 'Personalizado', value: 'custom'},
          {text: 'Turno', value: 'turn'}
        ],
        baseMissionId: null,
        whereSelected: [],
        rowbgalt: 'bg-row-alt',
        rowbg: 'bg-row',
        searchAction: false,
        searchVehicleValue: null,
        selections: [],
        // active: [],
        tree: [],
        /**
         * Nombre de la misión
         * @type {string}
         */
        name: null,
        /**
         * Descripción de la misión
         * @description Qué?
         * @type {string}
         */
        description: null,
        /**
         * Hora a la que inicia la misión
         * @description Cuando?
         * @type {string}
         */
        startTime: null,
        /**
         * Hora a la que termina la misión
         * @description Cuando?
         * @type {string}
         */
        endTime: null,
        /**
         * Fecha la que inicia la misión
         * @description Cuando?
         * @type {string}
         */
        startDate: null,
        /**
         * Fecha la que termina la misión
         * @description Cuando?
         * @type {string}
         */
        endDate: null,
        /**
         * Controla la visibilidad del selector de tiempo
         * @type {boolean}
         */
        startTimeMenu: false,
        endTimeMenu: false,
        /**
         * Controla la visibilidad del selector de fechas
         * @type {boolean}
         */
        startDateMenu: false,
        endDateMenu: false,
        /**
         * Vehiculos ligados a la misión
         *
         * @description Quienes?
         * @type {Array}
         */
        vehiclesAttached: [],
        /**
         * Poligonos asociados a la misión
         *
         * @description Donde?
         * @type {Array}
         */
        geofencesAttached: [],
        loadingSave: false,
        timeTypeSelection: null,
        dateTypeSelection: null,
        /**
         * Los multiples días que la misión puede estar disponible
         * @description Cuando?
         * @type {Array}
         */
        toggleMultipleDays: [],
        /**
         * Fecha seleccionada desde el selector de fecha que no está en popover
         * @type {string}
         */
        dateSelected: null,
        /**
         * Días del mes que puede funcionar una misión
         * @description Cuando?
         * @type {Array}
         */
        daysOfMonth: [],
        showMessageClearWho: false,
        analyzeParkingCheckbox: false
      }
    },
    computed: {
      ...mapGetters([
        'agenciesTree',
        'missionsTemplates'
      ]),
      ...mapGetters({
        fullZoneMaps: 'filters/fullZoneMaps',
        vehicles: 'getVehicles',
        geofences: 'getGeofences',
        adminRole: 'auth/adminRole'
      }),
      readyToSaveMission() {
        let value = false
        let time = this.processTime()
        let dates = this.processDate()
        let who = this.processWho()
        let where = this.processWhere()
        if (
          time.start &&
          time.end &&
          dates.start &&
          dates.end &&
          who.length > 0 &&
          where
        ) value = true
        return value
      },
      selected() {
        this.selections = []

        if (!this.activeM.length) return []
        this.recursiveSearchM(this.missionsTemplates)

        this.templatesIds = []
        this.templatesIds.push(this.templateSelectedIn.id)

        this.name = this.templateSelectedIn.name
        this.description = this.templateSelectedIn.description
        this.baseMissionId = this.templateSelectedIn.id
        const mission = {
          baseMissionId: this.baseMissionId,
          name: this.name,
          description: this.description,
          where: this.templateSelectedIn.where
        }
        this.selections.push(mission)
        this.match = false

        this.parentIdNext = this.templateSelectedIn.parentId

        if (this.templateSelectedIn.parentId !== null) {
          while (this.parentIdNext !== null) {
            // console.log('WHILE: ', this.parentIdNext)
            this.recursiveSearchUp(this.missionsTemplates, this.parentIdNext)
            this.matchUp = false
          }
        }

        const templatesUpLight = []

        this.templatesUp.forEach(element => {
          const tempObj = {}
          tempObj.name = element.name
          tempObj.description = element.description
          tempObj.where = element.where
          templatesUpLight.push(tempObj)
        })

        const fullSelection = this.selections.concat(templatesUpLight)
        this.selections = fullSelection.filter(item => item.where !== null)

        this.templateUpIn = null
        this.templatesUp = []
        this.matchUp = false

        return this.activeM
      }
    },
    watch: {
      selected(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.vehiclesAttached = []
          this.whereSelected = []
          this.clearSearch()
          // Always Analyze Parking false when selected
          this.analyzeParkingCheckbox = false
        }
      }
    },
    methods: {
      ...mapActions([
        'searchVehicleAction',
        'fetchMissionsTemplates',
        'createMission'
      ]),
      nextMission() {
        this.showDialogMessage = false
        this.initDataNextMission()
      },
      fihishCreateMission() {
        this.showDialogMessage = false
        this.initData()
      },
      endDateChanges() {
        this.startTime = null
        this.showEndTime = false
        this.endTime = null
      },
      startDateChanges() {
        this.endDate = null
      },
      initDataNextMission() {
        this.whereSelected = []
        this.searchAction = false
        this.searchVehicleValue = null
        this.vehiclesAttached = []
      },
      initData() {
        this.showEndTime = false
        this.turnTypesSelection = ''
        this.whenTypeSelection = ''
        this.baseMissionId = null
        this.whereSelected = []
        this.searchAction = false
        this.searchVehicleValue = null
        this.vehiclesAttached = []
        this.selections = []
        this.activeM = []
        this.clearWhenData()
      },
      clearWhenData() {
        this.startDate = null
        this.endDate = null
        this.startTime = null
        this.endTime = null
        this.startDateTurn = null
        this.endDateTurn = null
      },
      allowedDatesTurn(date) {
        if (this.startDateTurn) {
          let dateSelected = this.$moment(this.startDateTurn).format('YYYY-MM-DD')
          let datesResult = this.$moment(date).isSameOrAfter(dateSelected)
          return datesResult
        } else return false
      },
      allowedDatesCustom(date) {
        if (this.startDate) {
          let dateSelected = this.$moment(this.startDate).format('YYYY-MM-DD')
          let datesResult = this.$moment(date).isSameOrAfter(dateSelected)
          return datesResult
        } else return false
      },
      allowedMinutes(value) {
        if (this.startTime !== null && this.startDate === this.endDate) {
          const selectedStartTime = this.startTime.split(':')
          const selectedEndTime = this.endTime.split(':')
          if (value >= Number(selectedStartTime[1]) && Number(selectedStartTime[0]) === Number(selectedEndTime[0])) return true
          else if (Number(selectedStartTime[0]) !== Number(selectedEndTime[0])) return true
          else return false
        }
        return true
      },
      allowedHours(value) {
        if (this.startDate === this.endDate) {
          const selectedHour = this.startTime.split(':')
          if (value >= Number(selectedHour[0])) return true
          else return false
        } else return true
      },
      acceptStartTime() {
        this.$refs.startTime.save(this.startTime)
        if (this.startDate === this.endDate) {
          const nextDateTime = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'minute')
          this.endTime = this.$moment(nextDateTime).format('HH:mm')
          this.endDate = this.$moment(nextDateTime).format('YYYY-MM-DD')
        } else {
          this.endTime = '00:00'
        }
        this.showEndTime = true
      },
      changeStartTime() {
        this.endTime = null
      },
      clickedHourEndTime(value) {
        const currentStartHour = this.$moment(`${this.startDate} ${this.startTime}`).format('HH')
        if (Number(currentStartHour) === value) {
          this.endTime = this.$moment(`${this.startDate} ${this.startTime}`).add(1, 'minute').format('HH:mm')
        }
      },
      whereData(where) {
        console.log('WHERE', where)
        const items = []
        where.forEach(element => {
          const obj = {
            text: this.fullZoneMaps.get(element),
            value: element
          }
          items.push(obj)
        })
        console.log('ITEMS WHERE: ', items)
        const whereSort = items.sort(function(a, b) {
          var textA = a.text
          var textB = b.text
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })

        let counterSC = 0
        let counterSJ = 0
        const whereSortChecked = []
        for (let index = 0; index < whereSort.length; index++) {
          const element = whereSort[index]
          if (element.text === 'San Cristóbal A' || element.text === 'San Cristóbal B') {
            if (counterSC === 0) {
              whereSortChecked.push({
                text: 'San Cristóbal',
                value: [element.value]
              })
            } else {
              const indexIn = whereSortChecked.findIndex(item => item.text === 'San Cristóbal')
              if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
            }
            counterSC++
          } else if (element.text === 'San Javier A' || element.text === 'San Javier B') {
            if (counterSJ === 0) {
              whereSortChecked.push({
                text: 'San Javier',
                value: [element.value]
              })
            } else {
              const indexIn = whereSortChecked.findIndex(item => item.text === 'San Javier')
              if (indexIn !== -1) whereSortChecked[indexIn].value.push(element.value)
            }
            counterSJ++
          } else whereSortChecked.push(element)
        }

        return whereSortChecked
      },
      addWho(vehicle) {
        // console.log('ADD WHO: ', vehicle)
        const index = this.vehiclesAttached.findIndex(item => item.id === vehicle.id)
        if (index === -1) this.vehiclesAttached.push(vehicle)
        this.clearSearch()
      },
      clearSearch() {
        this.searchAction = false
        this.searchVehicleResult = []
      },
      searchVehicle() {
        this.searchVehicleResult = []
        // console.log('SEARCH', this.searchVehicleValue)
        this.vehicleAlreadyAdded = false
        // console.log('+ this.templateSelectedIn.agencyId:', this.templateSelectedIn.agencyId)
        // console.log('* this.templateSelectedIn.disabledAgencies:', this.templateSelectedIn.disabledAgencies)
        if (this.searchVehicleValue !== null) {
          this.searchAction = false
          this.searchVehicleAction(this.searchVehicleValue)
            .then(result => {
              let inGroup = true
              let restriction = -1
              // console.log('RESULT: ', result)
              if (result.length > 0) {
                const agencyIdResult = result[0].agencyId
                // console.log('agencyIdResult: ', agencyIdResult)
                this.parentIdNext = agencyIdResult
                this.selectionsAgencies = []
  
                // console.log('templateSelectedIn', this.templateSelectedIn)
                this.active[0] = this.templateSelectedIn.agencyId
                if (this.active[0] !== null) {
                  this.recursiveSearch(this.agenciesTree)
                  // console.log('AGENCY SELECTED: ', this.agencySelectedIn, this.active)
                }

                this.agencyIds = []
                this.recursiveSearchIn(this.agencySelectedIn)
                this.agencyIds.push(this.templateSelectedIn.agencyId)
                // console.log('AGENCIES ID IN: ', this.agencyIds)

                inGroup = this.agencyIds.includes(agencyIdResult)
                // console.log('MATCH GROUP: ', inGroup)
  
                if (this.templateSelectedIn.disabledAgencies !== null) {
                  while (this.parentIdNext !== null) {
                    // console.log('WHILE X: ', this.parentIdNext)
                    this.recursiveSearchUp(this.agenciesTree, this.parentIdNext)
                    this.matchUp = false
                  }
                  this.selectionsAgencies = this.templatesUp
                  // console.log('AGENCIES SELECTIONS: ', this.selectionsAgencies)
                  this.templatesUp = []
  
                  restriction = this.selectionsAgencies.findIndex(item => item.id === this.templateSelectedIn.disabledAgencies)
                  // console.log('RESTRICTION: ', restriction)
                }
                if (inGroup && restriction === -1) {
                  this.searchVehicleResult = result
                  const index = this.vehiclesAttached.findIndex(item => item.id === this.searchVehicleResult[0].id)
                  // console.log('vehicleAlreadyAdded - index', index)
                  if (index !== -1) this.vehicleAlreadyAdded = true
                }
              } else this.searchVehicleResult = result
              // this.searchVehicleValue = null
              this.searchAction = true
              // this.$refs.search.reset()
              // console.log('RESULT', this.searchVehicleResult)
            })
        }
      },
      /**
       * Metodo que limpia los vehiculos vinculados a la mision
       */
      clearVehicleList() {
        this.vehiclesAttached = []
      },
      /**
       * Metodo que solo permite verificar que  un item de la lista no este repetido cuando se agrega uno nuevo
       * @param event
       * @param list
       */
      handleChangeInDraggableList(event, list = []) {
        if ('added' in event) {
          let {element: newElement, newIndex} = event.added
          let queryElement = list.filter(listItem => listItem.id === newElement.id)
          if (queryElement.length > 1) {
            list.splice(newIndex, 1)
          }
        }
      },
      /**
       * Metodo que permite borrar un item de una lista arrastrable
       * @param index
       * @param list
       */
      deleteFromDraggableList(index, list) {
        list.splice(index, 1)
      },
      /**
       * Metodo que permite agregar un objecto a una lista arrastrable
       * @param item
       * @param list
       */
      addToDraggableList(item, list) {
        let isItemInList = list.filter(listItem => item.id === listItem.id)
        if (isItemInList.length === 0) {
          list.push(item)
        }
      },
      /**
       * Metodo que guarda la misión con un llamado asincrono a API
       *
       * Primero captura los datos basicos: Nombre y descripción.
       * Luego en los metodos  processTime, processDate, processWhere y processWho obtiene los datos correspondientes a: Cuando, Donde y Quien
       * Y envía la creacion desde el action `createMission`
       * Si lo crea correctamente vuelve a la vista de las misiones
       *
       * @returns {Promise<void>}
       */
      async saveMission() {
        try {
          this.loadingSave = true
          // let name = this.name
          // let description = this.description
          let time = this.processTime()
          let dates = this.processDate()
          // let where = this.processWhere()
          let who = this.processWho()

          this.selections.forEach(element => {
            element.baseMissionId = this.baseMissionId
            element.time = time
            element.dates = dates
            element.who = who
            // element.who = [4, 5]
            element.analyzeParking = this.analyzeParkingCheckbox
          })

          // const idWhereSelected = []
          // if (this.whereSelected.length > 0) {
          //   this.whereSelected.forEach(element => {
          //     console.log(element)
          //     idWhereSelected.push(this.fullZoneMaps.keys(element))
          //   })
          // }
          // console.log('ID WHERE SELECTED: ', idWhereSelected)
          const index = this.selections.findIndex(item => item.where.length > 1)
          // console.log('TEMP SELECTION: ', index)

          if (index >= 0) {
            const whereSelectedChecked = []
            this.whereSelected.forEach(element => {
              const isArrayEl = Array.isArray(element)
              if (isArrayEl) {
                element.forEach(elementIn => {
                  whereSelectedChecked.push(elementIn)
                })
              } else whereSelectedChecked.push(element)
              console.log('whereSelectedChecked', whereSelectedChecked)
            })
            this.selections[index].where = whereSelectedChecked
          }
          // console.log('SELECTIONS FULL: ', this.selections)

          // const newMission = await this.createMission(this.selections)
          // console.log('SELECTION INFO TO SAVE: ', this.selections)
          await this.createMission(this.selections.reverse())
          // if (newMission) {
          // console.info('Mission uploaded')

          // INTIALIZE DATA
          // this.initData()
          const message = {
            title: 'Misión Creada',
            text: 'Misión creadad correctamente. Desea Continuar creando misiones relacionadas a la selección actual, o Terminar?'
          }
          this.messageToShow = message
          this.showDialogMessage = true
  
          //   this.$router.back()
          // }
        } catch (e) {
          console.error(e)
          alert(e)
        } finally {
          this.loadingSave = false
        }
      },
      /**
       * Procesa el tiempo, ya sea en un rango personalizado, siempre o 15 minutos
       *
       * @returns {*}
       */
      processTime() {
        switch (this.whenTypeSelection) {
          case 'custom':
            return {
              start: this.startTime,
              end: this.endTime
            }
          case 'turn': {
            return {
              start: this.turnTypesSelection[0],
              end: this.turnTypesSelection[1]
            }
          }
          // case 'custom':
          //   return {
          //     start: this.startTime,
          //     end: this.endTime
          //   }
          // case 'always':
          //   return {
          //     start: '00:00:00',
          //     end: '23:59:59'
          //   }
          // case 'atLeast':
          //   return {
          //     atLeast: '15'
          //   }
          default:
            return {}
        }
      },
      /**
       * Procesa la fecha dependiendo de si va en un rango especifico(Custom), Son días de la semana(daysOfWeek),
       * son días en el año(daysOfMonth) o empieza desde una fecha hacía adelante(indeterminated)
       *
       * @returns {*}
       */
      processDate() {
        switch (this.whenTypeSelection) {
          case 'custom':
            return {
              start: this.startDate,
              end: this.endDate
            }
          case 'turn': {
            let startDateSwitch = this.startDateTurn
            let endDateSwitch = this.startDateTurn
            if (this.turnTypesSelection[0] === '22:00') {
              const tempStartDate = this.$moment(this.startDateTurn).format('YYYY-MM-DD')
              endDateSwitch = this.$moment(tempStartDate).add(1, 'day').format('YYYY-MM-DD')
            }
            // console.log('PROCESS DATE: ', startDateSwitch, endDateSwitch)
            return {
              start: startDateSwitch,
              end: endDateSwitch
            }
          }
          // case 'custom':
          //   return {
          //     start: this.startDate,
          //     end: this.endDate
          //   }
          // case 'daysOfWeek':
          //   return {
          //     daysOfWeek: this.toggleMultipleDays
          //   }
          // case 'daysOfMonth':
          //   return {
          //     daysOfMonth: this.daysOfMonth
          //   }
          // case 'indeterminated':
          //   return {
          //     start: this.startDate,
          //     end: '0000-00-00'
          //   }
          default:
            return {}
        }
      },
      /**
       * Devuelve un array con los ids de las poligonos que se van a vincular a la misión
       * @returns {number[]}
       */
      processWhere() {
        // return this.geofencesAttached.map(fence => {
        //   return fence.id
        // })

        let result = false

        for (let index = 0; index < this.selections.length; index++) {
          const element = this.selections[index]
          const lengthWhere = element.where.length
          // console.log('lengthWhere', lengthWhere)
          if (lengthWhere === 1) result = true
          else if (lengthWhere > 1) result = this.whereSelected.length > 0
          else result = false
          // console.log('result for', result)
          if (!result) break
        }

        // this.selections.forEach(element => {
        //   const lengthWhere = element.where.length
        //   console.log('lengthWhere', lengthWhere)
        //   if (lengthWhere === 1) result = true
        //   else if (lengthWhere > 1) result = this.whereSelected.length > 0
        //   else result = false
        // })

        // console.log('PROCESS WHERE', result, this.selections.length)
        return result
      },
      /**
       * Devuelve un array con los ids de los vehiculos que se van a vincular a la misión
       * @returns {number[]}
       */
      processWho() {
        return this.vehiclesAttached.map(vehicle => {
          return vehicle.id
        })
      },
      clearVehiclesAttached() {
        this.showMessageClearWho = true
      },
      clearVehiclesFromMessage() {
        this.vehiclesAttached = []
      },
      closeMessageClearWho() {
        this.showMessageClearWho = false
      },
      allowedDatesStartDate(date) {
        let today = this.$moment.now()
        today = this.$moment(today).format('YYYY-MM-DD')
        let yesterday = this.$moment(today).subtract(1, 'day')
        yesterday = this.$moment(yesterday).format('YYYY-MM-DD')
        const datesResult = this.$moment(date).isSameOrAfter(yesterday)
        return datesResult
      },
      allowedEndHour(value) {
        let result = true
        // let today = this.$moment.now()
        // const currentDate = this.$moment(today).format('YYYY-MM-DD')
        if (this.startDate === this.endDate) {
          let currentStartHour = this.$moment(`${this.startDate} ${this.startTime}`)
          currentStartHour = this.$moment(currentStartHour).format('HH')
          result = !(value < Number(currentStartHour))
        }
        return result
      },
      allowedEndMinute(value) {
        let result = true
        // let today = this.$moment.now()
        // const currentDate = this.$moment(today).format('YYYY-MM-DD')
        const currentStartHour = this.$moment(`${this.startDate} ${this.startTime}`).format('HH')
        if (this.startDate === this.endDate) {
          const tempTime = this.$refs.endTimePicker.value.split(':')
          if (Number(currentStartHour) === Number(tempTime[0])) {
            const currentMinute = this.$moment(`${this.startDate} ${this.startTime}`).format('mm')
            result = !(value <= Number(currentMinute))
          }
        }
        return result
      }
    },
    /**
     * Metodo que trae los vehiculos y la información de poligonos geoespaciales cuando se va a crear una misión
     */
    mounted() {
      this.$store.dispatch('fetchVehicles')
      this.$store.dispatch('fetchGeofencesData')
    },
    created() {
      if (this.missionsTemplates.length === 0) this.fetchMissionsTemplates()
    }
  }
</script>

<style scoped lang="scss">
.CreateMissionView__card > .list {
  background: #303030;
}

#container-who-0::-webkit-scrollbar-track
{
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #303030;
}

#container-who-0::-webkit-scrollbar
{
  width: 10px;
  background-color: #303030;
}

#container-who-0::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #616161;
}

.container-search-result {
  background-color: #303030;
  border-radius: 2px;
  height: 100px;
  margin-top: -20px;
}

.list-who {
  min-width: 300px;
}

.scroll-section {
  background-color: #303030;
  border-radius: 2px;
  height: 290px;
  overflow: auto;
}


.bg-row-alt {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 2px;
  padding-left: 10px;
  padding-right: 10px;
}
.bg-row {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  padding-left: 10px;
  padding-right: 10px;
}

.plate-border {
  border: 2px solid grey;
  border-radius: 5px;
}

.pointer-1 {
  cursor: pointer;
}

.pointer-1:hover {
  opacity: 0.7;
}

.info-vehicle-r {
  background-color: #616161;
  height: 40px;
  margin-bottom: 1px;
  border-radius: 2px;
}

.name-selection {
  color: #424242;
}

.description-selection {
  color: #616161;
}
</style>



// WEBPACK FOOTER //
// src/components/Missions/CreateMissionView.vue